import { deepFocusTrap } from './index'

export default function (config) {
  return new deepFocusTrap(config)
}
